import * as React from 'react';

export const BlueIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M12.0054 7.69765C14.911 7.69765 17.4117 9.46516 18.5232 11.9998C18.9159 11.0976 19.1394 10.1034 19.1394 9.05394C19.1394 5.04637 15.9439 1.7998 11.9994 1.7998C8.05486 1.7998 4.85938 5.04637 4.85938 9.05394C4.85938 10.1034 5.08288 11.1038 5.47552 11.9998C6.59907 9.46516 9.09988 7.69765 12.0054 7.69765Z"
        fill="#0081C6"
      />
      <path
        d="M11.9934 16.3022C9.0878 16.3022 6.58699 14.5346 5.47552 12C5.08288 12.9022 4.85938 13.8964 4.85938 14.9459C4.85938 18.9534 8.05486 22.2 11.9994 22.2C15.9439 22.2 19.1394 18.9534 19.1394 14.9459C19.1394 13.8964 18.9159 12.896 18.5232 12C17.4057 14.5346 14.9049 16.3022 11.9934 16.3022Z"
        fill="#80B0E5"
      />
      <path
        d="M12.0011 16.5899C14.9566 16.5899 17.5005 14.8089 18.6311 12.2549C17.5005 9.70094 14.9566 7.91992 12.0011 7.91992C9.04555 7.91992 6.5017 9.70094 5.37109 12.2549C6.5017 14.8089 9.04555 16.5899 12.0011 16.5899Z"
        fill="#0047BB"
      />
    </svg>
  );
};
